'use client'

import { CheckCircle2, CircleAlert, X } from 'lucide-react'
import { useEffect } from 'react'

export function Toast({ message, tone = 'success', onClose, duration = 4200 }: { message: string; tone?: 'success' | 'error' | 'info'; onClose: () => void; duration?: number }) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, duration)
    return () => window.clearTimeout(timer)
  }, [duration, message, onClose])
  return <div className={`appToast ${tone}`} role={tone === 'error' ? 'alert' : 'status'} aria-live="polite">
    <span className="appToastIcon">{tone === 'success' ? <CheckCircle2 /> : <CircleAlert />}</span>
    <p>{message}</p>
    <button type="button" onClick={onClose} aria-label="Fechar notificação"><X /></button>
    <i style={{ animationDuration: `${duration}ms` }} />
  </div>
}
